type SkippedCount = { count: number; noun: string };

/**
 * Builds the HTML comment that marks a run of dropped content, e.g.
 * `<!-- skipped 24 paragraphs and 2 tables -->`. Counts of zero are omitted,
 * nouns are pluralized by count, and multiple parts are joined with "and".
 * Returns null when nothing was skipped (so callers can skip emitting).
 */
export function formatSkippedComment(parts: SkippedCount[]): string | null {
  const phrases = parts
    .filter(part => part.count > 0)
    .map(part => `${part.count} ${part.noun}${part.count === 1 ? '' : 's'}`);
  if (phrases.length === 0) return null;
  return `<!-- skipped ${phrases.join(' and ')} -->`;
}
